const MIN = 10;
const COLORS = ['gray', 'green', 'yellow', 'orange', 'red', 'blank'];
const colorChange = (item, color) => item?.[color] && item?.[color] < MIN;

const needToChange = (item) => COLORS.filter((color) => colorChange(item, color)).length > 0;

const changeItem = (item) => {
    const total = COLORS.map((color) => item[color])
        .filter((value) => value)
        .reduce((a, b) => a + b, 0);

    const resizeColors = COLORS.map((color) => {
        const value = item[color];
        if (value === undefined) return { color };
        if (!value || value >= MIN) return { color, value };
        return { color, value: MIN };
    });

    const newTotal = resizeColors
        .map((col) => col.value)
        .filter((val) => val)
        .reduce((a, b) => a + b, 0);

    const rescale = total / newTotal;
    const ret = {
        date: item.date,
        count: item.count,
    };
    resizeColors.forEach((colValue) => {
        if (colValue.value === undefined) {
            ret[colValue.color] = undefined;
        } else {
            ret[colValue.color] = colValue.value * rescale;
        }
    });
    return ret;
};

export const resizeStatusCounts = (item) => {
    if (!needToChange(item.value)) return item;
    return {
        date: item.date,
        value: changeItem(item.value),
    };
};
